import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles(
  ({ palette, shape, custom, breakpoints }: Theme) => ({
    formControl: {
      width: '100%',
    },
    inputFormControl: {
      border: `1px solid #9d9d9d`,
      borderRadius: shape.borderRadius,
      'label + &': {
        margin: 0,
      },
    },
    inputDisabled: {
      border: 0,
    },
    inputFocused: {
      boxShadow: '0 0 0 3px rgba(255, 102, 0, 0.2)',
    },
    autocomplete: {
      width: '100%',
    },
    listbox: {
      padding: 5,
      scrollbarColor: 'light',
      scrollbarWidth: 'thin',
      '& li': {
        border: '2px solid transparent',
        borderRadius: '2px',
        '&[aria-selected="true"]': {
          backgroundColor: custom.status.warning.main,
          border: '2px solid #f06000',
        },
        '&[data-focus="true"]': {
          backgroundColor: custom.status.warning.main,
          border: '2px solid #f06000',
        },
      },
      '&::-webkit-scrollbar': {
        width: 6,
        height: 6,
        borderRadius: 6,
      },
      '&::-webkit-scrollbar-track': {
        boxShadow: 'transparent',
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: '#d0d5e1',
        borderRadius: 6,
      },
    },
    input: {
      minHeight: 46,
    },
    chipRoot: {
      [breakpoints.down('xs')]: {
        maxWidth: 215,
      },
      height: 28,
      fontSize: 14,
      borderRadius: shape.borderRadius,
    },
    chipDeleteIcon: {
      height: 12,
      width: 12,
      marginRight: 12,
      color: palette.common.white,
    },
    typeField: {
      '& label': {
        transform: 'translate(14px, 19px) scale(1)',
      },
    },
    inputChooseNew: {
      minWidth: '120px !important',
    },
    select: {
      paddingLeft: 10,
      '&:focus': {
        borderRadius: shape.borderRadius,
        background: palette.background.default,
      },
    },
    colorSecondary: {
      '&$checked': {
        color: palette.primary.main,
      },
    },
    listItemText: {
      fontSize: 14,
      fontWeight: 'normal',
      color: custom.grey[3],
    },
    caption: {
      position: 'absolute',
      bottom: 12,
      right: 40,
    },
    captionWithCheckIcon: {
      right: 40,
    },
    selectDisabled: {
      backgroundColor: custom.grey[0],
    },
    hideSelectIcon: {
      display: 'none',
    },
    popper: {
      zIndex: 10,
    },
  })
);
